import actions from './actions';
import { exportCommonFile } from "../../../helpers/utilities";


const initState = {
    createDetails: '',
    createData: '',
    createError: '',
    createLoader: false,
    deleteLoader: false,
    deleteDetails: '',
    deleteError: '',
    editLoader: false,
    editDetails: '',
    editData: '',
    editError: '',
    readLoader: true,
    readDetails: '',
    readError: '',
    getDetails: '',
    getList: '',
    getLoader: true,
    getData: '',
    importLoader: false,
    importDetails: '',
    importError: '',
    exportLoader: false,
    exportDetails: '',
    exportError: '',

    pdfLoader: false,
    pdfDetails: '',
    pdfError: '',
};

export default function crudReducer(state = initState, action) {
    switch (action.type) {
        case actions.CREATE_DETAILS_START: {
            return {
                ...state,
                createDetails: '',
                createError: '',
                createData: '',
                createLoader: true
            }
        }
        case actions.CREATE_DETAILS_SUCCESS: {
            return {
                ...state,
                createDetails: action.payload,
                createData: action.data,
                createError: '',
                createLoader: false
            }
        }
        case actions.CREATE_DETAILS_FAILURE: {
            return {
                ...state,
                createDetails: '',
                createError: action.message,
                createData: '',
                createLoader: false
            }
        }
        case actions.DELETE_DETAILS_START: {
            return {
                ...state,
                deleteLoader: true,
                deleteDetails: '',
                deleteError: '',
            };
        }
        case actions.DELETE_DETAILS_SUCCESS: {
            return {
                ...state,
                deleteLoader: false,
                deleteDetails: action.payload,
                deleteError: '',
            };
        }
        case actions.DELETE_DETAILS_FAILURE: {
            return {
                ...state,
                deleteLoader: false,
                deleteDetails: '',
                deleteError: action.message,
            };
        }
        case actions.EDIT_DETAILS_START: {
            return {
                ...state,
                editLoader: true,
                editDetails: '',
                editError: '',
                editData: '',
            };
        }
        case actions.EDIT_DETAILS_SUCCESS: {
            return {
                ...state,
                editLoader: false,
                editDetails: action.payload,
                editError: '',
                editData: action.data,
            };
        }
        case actions.EDIT_DETAILS_FAILURE: {
            return {
                ...state,
                editLoader: false,
                editDetails: '',
                editError: action.message,
                editData: '',
            };
        }
        case actions.READ_DETAILS_START: {
            return {
                ...state,
                readLoader: true,
                readDetails: '',
                readError: '',
            };
        }
        case actions.READ_DETAILS_SUCCESS: {
            return {
                ...state,
                readLoader: false,
                readDetails: action.payload,
                readError: '',
            };
        }
        case actions.READ_DETAILS_FAILURE: {
            return {
                ...state,
                readLoader: false,
                readDetails: '',
                readError: action.message,
            };
        }
        case actions.GET_DETAILS_START: {
            return {
                ...state,
                getLoader: true,
                getData: ''
            };
        }
        case actions.GET_DETAILS_SUCCESS: {
            if ((action.data.length === 0 && action.skip === 0) || action.skip === 0) {
                return {
                    ...state,
                    getLoader: false,
                    getList: action.data,
                    getData: action.data,
                }
            } else if (action.data.length === 0) {
                return {
                    ...state,
                    getData: action.data,
                    getLoader: true
                }
            } else {
                return {
                    ...state,
                    getList: [
                        ...state.getList,
                        ...action.data
                    ],
                    getData: action.data,
                    getLoader: false,
                    getDetails: action.payload,
                }
            }
        }
        case actions.GET_DETAILS_FAILURE: {
            // A failed fetch must RESOLVE the list spinner, not hang it. The
            // infinite-scroll pages only flip `loadMore` (which stops the spinner)
            // when `getData` becomes a truthy array on a successful response, so a
            // failure that leaves `getData` as '' spins forever — e.g. offline, when
            // an endpoint that isn't cached fast-fails with 503. Surface an empty
            // result so the page shows its empty/error state. Seed `getList` to []
            // only on the initial load (never populated) so a load-more failure
            // keeps the rows already on screen.
            return {
                ...state,
                getLoader: false,
                getList: state.getList === '' ? [] : state.getList,
                getData: [],
            };
        }
        case actions.IMPORT_START: {
            return {
                ...state,
                importLoader: true,
                importDetails: '',
                importError: '',
            };
        }
        case actions.IMPORT_SUCCESS: {
            return {
                ...state,
                importLoader: false,
                importDetails: action.data,
                importError: '',
            };
        }
        case actions.IMPORT_FAILURE: {
            return {
                ...state,
                importLoader: false,
                importDetails: '',
                importError: action.message,
            };
        }
        case actions.EXPORT_START: {
            return {
                ...state,
                exportLoader: true,
                exportDetails: '',
                exportError: '',
            };
        }
        case actions.EXPORT_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                exportLoader: false,
                exportDetails: action.data,
                exportError: '',
            };
        }
        case actions.EXPORT_FAILURE: {
            return {
                ...state,
                exportLoader: false,
                exportDetails: '',
                exportError: action.message,
            };
        }

        case actions.PDFGENERATE_START: {
            return {
                ...state,
                pdfLoader: true,
                pdfDetails: '',
                pdfError: '',
            };
        }
        case actions.PDFGENERATE_SUCCESS: {
            return {
                ...state,
                pdfLoader: false,
                pdfDetails: action.data,
                pdfError: '',
            };
        }
        case actions.PDFGENERATE_FAILURE: {
            return {
                ...state,
                pdfLoader: false,
                pdfDetails: '',
                pdfError: action?.message || action?.msg || 'Something went Wrong',
            };
        }
        case actions.CLEAR_GET_DETAILS_START: {
            return {
                ...state,
                getLoader: true
            };
        }
        case actions.CLEAR_GET_DETAILS_SUCCESS: {
            return {
                ...state,
                getLoader: false,
                getList: [],
            };
        }
        case actions.CLEAR_CRUD_DETAILS_START: {
            return {
                ...state,
            };
        }
        case actions.CLEAR_CRUD_DETAILS_SUCCESS: {
            return initState;
        }

        default:
            return state;
    }
}